import React from 'react';
import { Button } from '@zurich-primitives/button';
import styles from './DownloadCSVButton.module.scss';
import { IDownloadCSVButton } from './DownloadCSVButton.interface';

export const DownloadCSVButton: React.FC<IDownloadCSVButton> = ({
  handleOnClick,
  isDisabled
}) => {
  return (
    <div className={styles['btn-container']}>
      <Button
        className={styles['btn-csv']}
        onClick={handleOnClick}
        disabled={isDisabled}
        variant="secondary"
      >
        <Button.Label>Download CSV</Button.Label>
      </Button>
    </div>
  );
};
